<div class="text container__text {{getClass()}} markdown-container" [innerHTML]="markdown"></div>
